export const FhirResourceTypes = {
  Patient: 'Patient',
  AllergyIntolerance: 'AllergyIntolerance',
  Immunization: 'Immunization',
  FamilyMemberHistory: 'FamilyMemberHistory',
  ServiceRequest: 'ServiceRequest',
  Observation: 'Observation',
  Condition: 'Condition',
  MedicationRequest: 'MedicationRequest',
  Procedure: 'Procedure',
  DiagnosticReport: 'DiagnosticReport',
  Encounter: 'Encounter',
  Binary: 'Binary'
};
